
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#008CE1","fill-rule":"evenodd","d":"M4.426 10.422a.837.837 0 01-1.181 0 .832.832 0 010-1.179L8 4.5l4.755 4.744a.832.832 0 010 1.179.837.837 0 01-1.18 0L8 6.856l-3.574 3.566z"}})])
          )
        }
      }
    